import React from 'react'
import {Box, Avatar} from "@mui/material";
import BtnSecondary from "./SecondaryButton";
import ProgressBar from './ProgressBar';
import DocsIcon from '../assets/icons/docs.svg';

const PolicyListingHeader = ({Heading, ButtonText, ButtonLink}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "2rem", alignItems:"end" }}>
             <Box>
                <Box sx={{display:"flex"}}>
                   <Avatar src={DocsIcon} style={{ width: '1.5rem', height: '1.5rem' }}/>
                   <Box sx={{fontWeight:400, fontSize:"1rem", lineHeight: 1.7, color:"#8C3B5E", marginBottom: "0.5rem"}}>
                      {Heading}
                   </Box>
                </Box>
                <ProgressBar value={100}/>
             </Box>
             <BtnSecondary
               to={ButtonLink}
               sx={{ borderRadius: "10px",paddingBlock: "1.25rem", height: "3rem" }}
             >
               {ButtonText}
             </BtnSecondary>
    </Box>
  )
}

export default PolicyListingHeader